import { MapPin } from "lucide-react";
import { Reveal, MaskedLine } from "./Reveal";
import { waLink, DEFAULT_WA_MESSAGE, BRAND } from "../../lib/site";
import { WhatsAppIcon } from "./Header";

export default function Footer() {
  return (
    <footer data-testid="footer-section" className="relative border-t border-white/5 overflow-hidden">
      <div className="absolute inset-0 glow-amber pointer-events-none" />
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-24 relative">
        <Reveal>
          <img
            src="/logo.png"
            alt="NVS Automotiva"
            className="h-24 sm:h-28 w-auto mb-10 drop-shadow-[0_0_30px_rgba(232,17,45,0.35)]"
          />
        </Reveal>
        <h2 className="font-display font-extrabold uppercase tracking-tight leading-[1.02] text-4xl sm:text-5xl lg:text-6xl">
          <MaskedLine>Precisa de socorro</MaskedLine>
          <MaskedLine delay={0.15}>
            <span className="text-[#e8112d] text-glow">agora?</span>
          </MaskedLine>
        </h2>

        <Reveal delay={0.25}>
          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <a
              href={waLink(DEFAULT_WA_MESSAGE)}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-whatsapp-btn"
              className="inline-flex items-center justify-center gap-3 bg-[#25D366] hover:bg-[#20BD5A] text-black font-bold text-base px-9 py-4 rounded-full transition-all duration-300 hover:scale-[1.03] hover:shadow-2xl hover:shadow-[#25D366]/25"
            >
              <WhatsAppIcon className="w-5 h-5" />
              Chamar no WhatsApp — 24h
            </a>
          </div>
        </Reveal>

        <div className="mt-20 pt-8 border-t border-white/5 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-5">
          <div className="flex items-center gap-2 text-slate-500 text-sm">
            <MapPin className="w-4 h-4 text-[#e8112d]" />
            Balneário Camboriú · Itajaí · Camboriú · Itapema — SC · Base móvel
          </div>
          <p className="font-tech text-[11px] uppercase tracking-[0.2em] text-slate-600">
            © {new Date().getFullYear()} {BRAND} · Auto Elétrica Móvel 24h
          </p>
        </div>
      </div>
    </footer>
  );
}
